module.exports = __webpack_public_path__ + "static/media/team.e16723a3.png";